export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [
  {
    id: 'tenant-management',
    auth: ['tenantManagement'],
    title: 'Tenant Management',
    messageId: 'Tenant Management',
    type: 'item',
    icon: 'apps',
    url: '/tenant-management',
  },
  {
    id: 'permissions-management',
    auth: ['permissionsManagement', 'userManagement'],
    title: 'App Permissions Management',
    messageId: 'User Permissions Management',
    type: 'item',
    icon: 'people',
    url: '/user-management/permissions',
  },
  {
    id: 'contact-entry-points',
    auth: ['flowEngineManagement', 'entryManagement'],
    title: 'Contact Entry Points',
    messageId: 'Contact Entry Points',
    type: 'item',
    url: '/contact-entry-points',
    icon: 'play_circle',
  },
  {
    id: 'menu-management',
    auth: ['flowEngineManagement', 'entryManagement'],
    title: 'Menu Management',
    messageId: 'Menu Management',
    type: 'item',
    url: '/menu-management',
    icon: 'dialpad',
  },
  {
    id: 'config-set-management',
    auth: ['admin'],
    title: 'Configuration Set',
    messageId: 'Configuration Set',
    type: 'item',
    url: '/contact-flows',
    icon: 'settings',
  },

  {
    id: 'queue-treatment',
    auth: ['flowEngineManagement', 'queueTreatmentManagement'],
    title: 'Queue Treatment',
    messageId: 'Queue Treatment',
    type: 'item',
    url: '/queue-treatment',
    icon: 'perm_phone_msg',
  },

  {
    id: 'environment-sync-management',
    auth: ['syncManagement'],
    title: 'Environment Sync Management',
    messageId: 'Environment Sync Management',
    icon: 'compare_arrows',
    type: 'collapse',
    children: [
      {
        id: 'path-mappings-management',
        auth: ['syncManagement'],
        title: 'Path / Attribute Mappings',
        messageId: 'Path / Attribute Mappings',
        type: 'item',
        url: '/sync/path-mappings',
      },
      {
        id: 'contact-flow-sync-management',
        auth: ['syncManagement'],
        title: 'Contact Flow Sync',
        messageId: 'Contact Flow Sync',
        type: 'item',
        url: '/sync/contact-flows',
      },
      {
        id: 'config-set-sync-management',
        auth: ['syncManagement'],
        title: 'Config Set Sync',
        messageId: 'Config Set Sync',
        type: 'item',
        url: '/sync/config-sets',
      },
    ],
  },
  {
    id: 'calender-management',
    auth: [
      'calendarManagement',
      'holidaysManagement',
      'hoursOfOperationManagement',
      'closuresManagement',
    ],
    title: 'Calender Management',
    messageId: 'Calender Management',
    type: 'collapse',
    icon: 'event',
    children: [
      {
        id: 'holiday-management',
        auth: ['calendarManagement', 'holidaysManagement'],
        title: 'Holiday Management',
        messageId: 'Holidays',
        type: 'item',
        url: '/calendar-management/holidays',
      },
      {
        id: 'hours-management',
        auth: ['calendarManagement', 'hoursOfOperationManagement'],
        title: 'Hours Management',
        messageId: 'Hours',
        type: 'item',
        url: '/calendar-management/hours',
      },
      {
        id: 'closures-management',
        auth: ['calendarManagement', 'closuresManagement'],
        title: 'Closures Management',
        messageId: 'Closures',
        type: 'item',
        url: '/calendar-management/closures',
      },
    ],
  },
  {
    id: 'connect-user-management',
    auth: ['connectUserManagement'],
    title: 'Connect User Management',
    messageId: 'Connect User Management',
    type: 'item',
    url: '/connect/user-management',
    icon: 'contacts',
  },
  {
    id: 'realtime-metrics',
    auth: [
      'metrics',
      'realTimeMetricsQueues',
      'realTimeMetricsRoutingProfiles',
      'realTimeMetricsAgents',
      'realTimeMetricsSnapshot'
    ],
    title: 'Realtime Metrics',
    messageId: 'Realtime Metrics',
    icon: 'assessment',
    type: 'collapse',
    children: [
      {
        id: 'realtime-metrics-stacked',
        auth: ['metrics', 'realTimeMetricsQueues', 'realTimeMetricsRoutingProfiles', 'realTimeMetricsAgents', 'realTimeMetricsSnapshot'],
        title: 'Stacked Metrics',
        messageId: 'All Metrics',
        type: 'item',
        url: '/connect/metrics/realtime-metrics/all-metrics',
      },
      {
        id: 'realtime-metrics-queues',
        auth: ['metrics', 'realTimeMetricsQueues'],
        title: 'Queues',
        messageId: 'Queues',
        type: 'item',
        url: '/connect/metrics/realtime-metrics/queues',
      },
      {
        id: 'realtime-metrics-routingprofiles',
        auth: ['metrics', 'realTimeMetricsRoutingProfiles'],
        title: 'Routing Profiles',
        messageId: 'Routing Profiles',
        type: 'item',
        url: '/connect/metrics/realtime-metrics/routingprofiles',
      },
      {
        id: 'realtime-metrics-agents',
        auth: ['metrics', 'realTimeMetricsAgents'],
        title: 'Agents',
        messageId: 'Agents',
        type: 'item',
        url: '/connect/metrics/realtime-metrics/agents',
      },
      {
        id: 'realtime-metrics-snapshot',
        auth: ['metrics', 'realTimeMetricsSnapshot'],
        title: 'Snapshot',
        messageId: 'Snapshot',
        type: 'item',
        url: '/connect/metrics/realtime-metrics/snapshot'
      }
    ],
  },
  // {
  //   id: 'historical-metrics',
  //   auth: ['metrics', 'historicalMetrics'],
  //   title: 'Historical Metrics',
  //   messageId: 'Historical Metrics',
  //   icon: 'assessment',
  //   type: 'collapse',
  //   children: [
  //     {
  //       id: 'historical-metrics-queues',
  //       auth: ['metrics', 'historicalMetrics'],
  //       title: 'Queues',
  //       messageId: 'Queues',
  //       type: 'item',
  //       url: '/connect/metrics/historical-metrics/queues',
  //     },
  //     {
  //       id: 'historical-metrics-agents',
  //       auth: ['metrics', 'historicalMetrics'],
  //       title: 'Agents',
  //       messageId: 'Agents',
  //       type: 'item',
  //       url: '/connect/metrics/historical-metrics/agents',
  //     },
  //     {
  //       id: 'historical-metrics-phonenumbers',
  //       auth: ['metrics', 'historicalMetrics'],
  //       title: 'Phone Numbers',
  //       messageId: 'Phone Numbers',
  //       type: 'item',
  //       url: '/connect/metrics/historical-metrics/phonenumbers',
  //     },
  //   ],
  // },
  {
    id: 'contact-search',
    auth: ['metrics', 'contactSearch'],
    title: 'Contact Search',
    messageId: 'Contact Search',
    type: 'item',
    url: '/connect/contact-search',
    icon: 'search',
  },
];
export default routesConfig;
